import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChatAppResponse } from "../../api";

export type ChatsState = {
    currentChat: [user: string, response: ChatAppResponse][];
};

const initialState: ChatsState = {
    currentChat: []
};

const chatsSlice = createSlice({
    name: "chats",
    initialState,
    reducers: {
        setCurrentChat: (state, action: PayloadAction<[user: string, response: ChatAppResponse][]>) => {
            state.currentChat = action.payload;
        }
    }
});

export const { setCurrentChat } = chatsSlice.actions;
export default chatsSlice.reducer;
